import styled from 'styled-components';
import * as Common from '../../../../../Styles';

const Theme = Common.Theme;

export const Root = styled(Common.FlexRow)`
	width: auto;
	padding: 0.5rem;
	gap: 0.5rem;
	border: 0px solid ${Theme.mediumGrey};
	border-bottom-width: 1px;
`;

export const Details = styled(Common.FlexColumn)`
	gap: 0.25rem;
`;

export const ProductName = styled(Common.FlexRow)`
	font-weight: bold;
`;

export const ProductNameContainer = styled.div`
	display: flex;
	flex-direction: ${(props) => (props.reverse ? 'row-reverse' : 'row')};
	font-family: Arial;
	justify-content: ${(props) => (props.align || 'flex-start')};
`;

export const ProductID = styled(Common.FlexRow)`
	color: ${Theme.darkGrey};
`;

export const ProductPrimary = styled(Common.Bold)`
	margin: 0;
	color: ${Theme.green};
`;

export const ProductCategory = styled(Common.FlexRow)`
	color: ${Theme.blue};
	font-weight: bold;
`;

export const ProductDescription = styled(Common.FlexRow)`
	color: ${Theme.mediumGrey};
`;
